module.exports = __webpack_public_path__ + "img/dlt_kind_7.svg.bak.23198980.svg";